import { mutationOptions, queryOptions } from '@tanstack/react-query';

import { client, HttpException, type components, type operations } from '@/libs/openapi';
import { queryNamespace } from '@/utils/query-namespace.util';

export const authQueries = queryNamespace('auth', {
  googleCallback: (data: operations['auth-google_callback']['parameters']['query']) => queryOptions({
    queryKey: [data],
    queryFn: ({ signal }) => client
      .GET('/api/v1/auth/google/callback', { params: { query: data }, signal })
      .then(({ data, error, response }) => {
        if (error) {
          throw new HttpException({ message: error.detail?.map(item => item.msg).join(', '), response });
        }

        return data;
      }),
  }),
});

export const authMutations = queryNamespace('auth', {
  login: mutationOptions({
    mutationFn: async (data: Omit<components["schemas"]["Body_auth-login"], 'scope'>) => {
      const formData = new URLSearchParams();

      Object.keys(data).forEach(key => formData.append(key, data[key as keyof typeof data]));

      return client
        .POST('/api/v1/auth/login', {
          body: formData as unknown as components["schemas"]["Body_auth-login"],
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(({ data, error, response }) => {
          if (error) {
            throw new HttpException({ message: typeof error.detail === 'string' ? error.detail : error.detail?.map(item => item.msg).join(', '), response });
          }

          return data;
        });
    },
  }),
  logout: mutationOptions({
    mutationFn: () => client
      .POST('/api/v1/auth/logout')
      .then(({ data, error }) => {
        if (error) {
          throw new HttpException();
        }

        return data;
      }),
    onSettled: (_data, _error, _variables, _onMutateResult, context) => {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      context.client.clear();
    },
  }),
  googleLogin: mutationOptions({
    mutationFn: () => client
      .GET('/api/v1/auth/google/login')
      .then(({ data, error }) => {
        if (error) {
          throw new HttpException();
        }

        return data;
      }),
  }),
});
